module.exports = __webpack_public_path__ + "img/dcu30-char-1.67dc3af1.png";